<input
  [value]="value | format: 'DURATION.DEFAULT'"
  placeholder="{{
    placeholder || '#UI_CORE.COMPONENTS.DURATION_INPUT.PLACEHOLDER' | translate
  }}"
  (change)="setValue(input.value)"
  [readOnly]="readonly"
  (blur)="onTouch()"
  #input
/>
